import { FC } from 'react'
import { DefaultDropdown } from './DefaultDropdown'
import { RoundedDropdown } from './RoundedDropdown'
import { DropdownLegacyProps, DropdownVariants } from './types'

export const variantComponents: {
  [x in DropdownVariants]: FC<DropdownLegacyProps>
} = {
  default: DefaultDropdown,
  rounded: RoundedDropdown,
}
